import ViewFantacyContests from './ViewFantacyContests';

export default ViewFantacyContests;